export * from './useProductDetailsContent';
